import React from "react";
import { FallingLines } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { ReactComponent as AddUserIcon } from "images/profile/user-add.svg";
import SkeletonIcon from "images/profile/Skeleton.png";
import AgencyTeamCards from "./cards";
import CreateNewMemberModal from "./agencyTeamModal/upsertNewMemberModal";
import useCreateNewMember from "./hooks/useCreateNewMember";
import useAgencyTeam from "./hooks/useAgencyTeam";
import Pagination from "components/pagination";
import Header from "components/header";

function AgencyTeam({}) {
  const [t] = useTranslation();

  const {
    totalCount,
    users,
    initLoading: listLoading,
    pagination,
    setPagination,
    defaultPagination,
    setUsers: updateUsersResult,
    userDetails = {},
    userDomains = [],
    userSubDomains = [],
    loadPage,
  } = useAgencyTeam({});

  const userRates = userDetails?.userRates ?? [];
  const userServices = userDetails?.userServices ?? [];

  const { isOpen, setIsOpen, onSubmit, isLoading } = useCreateNewMember({
    updateUsersResult,
    setPagination,
    defaultPagination,
  });

  if (loadPage) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <FallingLines
          color="#023A66"
          width="100%"
          visible={true}
          ariaLabel="falling-lines-loading"
        />
      </div>
    );
  }
  return (
    <>
      <Header />
      <div className="px-[80px] md-max:px-[1rem] flex flex-col my-[60px] md-max:my-[20px] relative">
        {isOpen && (
          <CreateNewMemberModal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            onSubmit={onSubmit}
            isLoading={isLoading}
            title={t("addNewMember")}
            userRates={userRates}
            userServices={userServices}
            userDomains={userDomains}
            userSubDomains={userSubDomains}
          />
        )}

        <div
          className="flex w-full flex-col gap-[20px]"
          id="agencyTeamScrollId"
        >
          <div className="flex justify-between items-center">
            <div className="text-primary font-semibold text-[30px] not-italic">
              {t("agencyTeam")}
            </div>
            <div
              className="flex justify-center items-center gap-[8px] rounded-[6px] cursor-pointer"
              onClick={() => setIsOpen(true)}
            >
              <AddUserIcon className="cursor-pointer" />
              <div className="text-primary font-semibold text-[16px] font-bold">
                {t("addNewMember")}
              </div>
            </div>
          </div>

          {listLoading ? (
            <div className="grid  md-max:grid-cols-1 grid-cols-2 items-center gap-[20px] w-full">
              <img
                src={SkeletonIcon}
                alt="SkeletonIcon"
                className="w-full object-cover"
              />
              <img
                src={SkeletonIcon}
                alt="SkeletonIcon"
                className="w-full object-cover"
              />
            </div>
          ) : (
            <AgencyTeamCards
              userDetails={userDetails}
              userDomains={userDomains}
              userSubDomains={userSubDomains}
              users={users}
              updateUsersResult={updateUsersResult}
              pagination={pagination}
            />
          )}
          {totalCount > 6 && (
            <Pagination
              currentPage={pagination.paginate.pageNumber}
              totalPages={Math.ceil(totalCount / pagination.paginate.pageSize)}
              onPageChange={(page) => {
                setPagination((prevState) => {
                  return {
                    ...prevState,
                    paginate: {
                      pageNumber: page,
                      pageSize: prevState.paginate.pageSize,
                    },
                  };
                });
                document
                  .getElementById("agencyTeamScrollId")
                  ?.scrollIntoView?.({
                    behavior: "smooth",
                    block: "start",
                  });
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default AgencyTeam;
